<template>
  <v-main app>
    <slot></slot>
  </v-main>
</template>
<script>
export default {
  name: 'MainLayout'
}
</script>
<style scoped>
.v-main {
  background-color:#E5E5EB;
}
</style>
